import { FlightCard } from "./FlightCard";

interface FlightResultsProps {
  data: {
    flights?: Array<{
      id: string;
      price: number;
      currency: string;
      airlines: string[];
      segments: Array<{
        departureAirport: string;
        departureTime: string;
        arrivalAirport: string;
        arrivalTime: string;
        airline: string;
        flightNumber: string;
        duration: string;
      }>;
      duration: string;
      stops: number;
      bookingUrl: string;
    }>;
    count?: number;
    error?: string;
  };
}

export function FlightResults({ data }: FlightResultsProps) {
  if (data.error) {
    return (
      <div className="rounded-lg border border-red-300/35 bg-red-400/10 p-3 text-sm text-red-200">
        Flight search error: {data.error}
      </div>
    );
  }

  if (!data.flights?.length) {
    return (
      <div className="rounded-lg border border-white/15 bg-white/5 p-3 text-sm text-ink-light">
        No flights found for these dates
      </div>
    );
  }

  return (
    <div className="space-y-2 my-2">
      <p className="text-xs text-ink-light font-medium">
        {data.count} flight{data.count !== 1 ? "s" : ""} found
      </p>
      {data.flights.map((flight) => (
        <FlightCard key={flight.id} flight={flight} />
      ))}
    </div>
  );
}
